export const getSearchResults = async (searchTerm) => {
  const contentfulResponse = await fetch('/api/get-contentful-search-data', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({searchTerm})
  });

  const shopifyResponse = await fetch('/api/get-shopify-search-data', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({searchTerm})
  });

  const contentfulData = await contentfulResponse.json();
  const shopifyData = await shopifyResponse.json();

  return {
    blogPosts: contentfulData.blogPosts,
    blogLists: contentfulData.blogLists,
    shopifyProducts: shopifyData.shopifyProducts
  };
};
